import React from 'react';
import './Hero.css';

const Hero = () => {
  return (
    <section className="hero" id="home">
      <div className="hero-background">
        <div className="hero-overlay"></div>
      </div>
      <div className="container">
        <div className="hero-content">
          <div className="hero-text">
            <h1>Solutions For</h1>
            <h2 className="hero-highlight">Data Engineering and Advanced Analytics</h2>
            <p className="hero-subtitle">SEEING IS BELIEVING</p>
            <div className="hero-actions">
              <button className="btn btn-primary">Get Started</button>
              <button className="btn btn-outline">Learn More</button>
            </div>
          </div>
          <div className="hero-visual">
            <div className="hero-cards">
              <div className="hero-card">
                <i className="fas fa-chart-line"></i>
                <h4>Data Analytics</h4>
              </div>
              <div className="hero-card">
                <i className="fas fa-robot"></i>
                <h4>AI Solutions</h4>
              </div>
              <div className="hero-card">
                <i className="fas fa-cloud"></i>
                <h4>Cloud Services</h4>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero; 